export const capitaliseFirstLetter = (word) => word.charAt(0).toUpperCase() + word.slice(1);

/**
 * Export of String.prototype.replaceAll()
 * Only required as this method is only available in ES2021.String which we can't include in Typescript at the moment
 */
const replaceAll = require('string.prototype.replaceall');
export { replaceAll };

export { toTitleCase } from './toTitleCase';

export { replaceNonPrintableChars } from './replaceNonPrintableChars';

export { resolveSpecialCharacterSequences } from './resolveSpecialCharacterSequences';
export { trimCharacter } from './trimCharacter';

export const isRegularExpression = (regex) => {
  try {
    new RegExp(regex);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Escapes special characters
 */
export const escapeRegularExpressionSpecialCharacters = (s) => s.toString().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
